import { useIdleTimer } from 'react-idle-timer';
import api from '../constants/api';
import { unregisterConfirmLeave } from './confirmLeave';

let resetSession: () => void;

export const checkSession = async (): Promise<void> => {
  const res = await api.checkSession.request();
  if (res.status === 401) {
    unregisterConfirmLeave();
    window.location.reload();
  } else {
    resetSession();
  }
};

const onAction = (): void => {
  checkSession();
  api.renewSession.request();
};

export const useSessionManager = (isDisabled: boolean) => {
  const { reset } = useIdleTimer({
    timeout: 1000 * 60 * 31,
    onIdle: checkSession,
    onAction: onAction,
    throttle: 1000 * 60 * 5,
    disabled: isDisabled,
  });

  resetSession = reset;

  return {
    reset: resetSession,
  };
};
